import graphql from "babel-plugin-relay/macro";

import { useMutationWithError } from "../../../../../../../utils/hooks/useMutationWithError";
import {
  UserContactStatus,
  useCheckUserEmailStatusNotificationsMutation,
} from "./__generated__/useCheckUserEmailStatusNotificationsMutation.graphql";

export const useCheckUserEmailStatusNotifications = () => {
  const [checkStatus, isChecking] =
    useMutationWithError<useCheckUserEmailStatusNotificationsMutation>(
      useCheckEmailNotificationsMutationString
    );

  const checkEmail = (
    email: string,
    onCompleteHandler: (
      value: string,
      result: UserContactStatus,
      type: "Email"
    ) => void
  ) => {
    checkStatus({
      variables: { input: { email } },
      onCompleted: (res) => {
        if (res.responsePayload?.success && res.responsePayload.result) {
          onCompleteHandler(email, res.responsePayload.result, "Email");
        }
      },
    });
  };
  return [checkEmail, isChecking] as const;
};

export const useCheckEmailNotificationsMutationString = graphql`
  mutation useCheckUserEmailStatusNotificationsMutation(
    $input: UserEmailStatusInput!
  ) {
    responsePayload: userEmailStatus(input: $input) {
      success
      result
      errors {
        field
        code
        message
      }
    }
  }
`;
